import React, { useContext } from "react";
import { IonItem, IonLabel, IonButton } from "@ionic/react";
import { AppConfigContext } from "../../context/AppConfigContext";
import { ProyectosContext } from "../../context/ProyectosContext";
import { DestajosContext } from "../../context/DestajosContext";
import { AvanceModeContext } from "../../context/AvanceModeContext";
import AvancePickerMobile from "./AvancePickerMobile";
import { getValue } from "../../utils";
import { renderNombreDestajo } from "../../utils/destajos";

const DestajoMobile = ({
  destajo,
  collapsed,
  setDestajo,
  getProyecto,
  toggleSubdestajos,
  hasChildren,
}) => {
  const appconfig = useContext(AppConfigContext);
  const { proyecto } = useContext(ProyectosContext);
  const { postAvanceDestajo } = useContext(DestajosContext);
  const { mode, inputType } = useContext(AvanceModeContext);

  const { idProyecto, permiso, idPermiso } = proyecto || {};

  console.log("DestajoMobile permiso:", permiso, "idPermiso:", idPermiso);

  const canEditProgress = () =>
    ["admin", "supervisor", "contratista"].includes(permiso) ||
    [3, 6].includes(parseInt(idPermiso));

  const concepto =
    Array.isArray(destajo.conceptos) && destajo.conceptos.length > 0
      ? destajo.conceptos[0]
      : null;
  const conceptoCantidad = concepto ? Number(concepto.cantidad) : NaN;
  const cantidad =
    concepto && concepto.cantidad != null ? concepto.cantidad : "-";
  const unidad = concepto && concepto.unidad ? concepto.unidad : "";

  // Amount mode applies only when the global toggle is "amount" and this destajo
  // has a concepto with a positive cantidad to measure against (mirrors DestajoTabla).
  const unitMode = mode === "amount" && !!concepto && conceptoCantidad > 0;
  // progreso is a 0-1 fraction; acumulado is the accumulated quantity of the unit.
  const acumulado =
    Math.round((destajo.progreso || 0) * conceptoCantidad * 100) / 100;

  const showPicker =
    (proyecto?.modo_avance || "destajo") === "destajo" &&
    getValue(appconfig, "progress") !== "money" &&
    canEditProgress();

  const postAvance = (cont, isManual) => {
    postAvanceDestajo(
      destajo.idDestajo,
      cont,
      idProyecto,
      getProyecto,
      isManual,
      unitMode ? concepto.idConcepto : undefined,
      unitMode
    );
  };
  const programado =
    destajo.programado !== null && !isNaN(parseFloat(destajo.programado))
      ? `${parseInt(parseFloat(destajo.programado) * 100)}%`
      : "-";

  return (
    <IonItem
      key={destajo.idDestajo}
      className="custom-ionitem"
      style={{
        // Aditiva: avance over 100%, highlighted like aditivo conceptos.
        ...(parseFloat(destajo.progreso) > 1 && { "--background": "#fffaea" }),
        "--background-focused": "transparent",
        "--background-activated": "transparent",
        "--background-hover": "transparent",
        "--ripple-color": "transparent",
      }}
    >
      <IonLabel className="ion-text-wrap" style={{ marginLeft: "1.6x" }}>
        <div className="d-flex align-items-center">
          {hasChildren && (
            <IonButton
              fill="light"
              className="btn btn-outline-primary p-0"
              style={{
                color: "white",
                width: "30px",
                height: "30px",
              }}
              onClick={() => toggleSubdestajos(destajo.idDestajo)}
            >
              <i className={`fa fa-chevron-${collapsed ? "down" : "up"}`}></i>
            </IonButton>
          )}
          <span
            className="small flex-grow-1 text-uppercase"
            style={{
              color: "#b76d4f",
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
            }}
          >
            {renderNombreDestajo(destajo)}
          </span>
          <IonButton
            fill="light"
            style={{ color: "#b76d4f" }}
            onClick={() => setDestajo(destajo)}
            className=" mx-1 px-1 border-0"
          >
            <i className="fa fa-info"></i>
          </IonButton>
        </div>
        <div className="d-flex align-items-center justify-content-between mt-2 w-100">
          {showPicker && (
            <div style={{ width: "60%" }}>
              <AvancePickerMobile
                permitirExcedente
                progreso={unitMode ? acumulado : parseInt(destajo.progreso * 100)}
                setCantidad={postAvance}
                intervalo={1}
                limite={unitMode ? conceptoCantidad : 100}
                inputType={inputType}
                suffix={unitMode ? unidad : "%"}
              />
            </div>
          )}
          <div className="small">
            <div>
              {/* Percentage mode: show the advance converted to the unit. */}
              {!unitMode && conceptoCantidad > 0 && (
                <>
                  <span className="text-primary bold">{acumulado}</span>
                  {" / "}
                </>
              )}
              <span>{cantidad}</span>
              {unidad && <span className="text-muted ms-1">{unidad}</span>}
            </div>
            <div>
              <span className="bold">{programado}</span>
              <span
                className="text-muted ms-1"
                style={{ fontSize: "0.55rem", lineHeight: 1 }}
              >
                programado
              </span>
            </div>
          </div>
        </div>
      </IonLabel>
    </IonItem>
  );
};

export default DestajoMobile;
